import React, { useState } from "react";
import "./Splits.css";

export default function Splits({ data }) {
  const [isOpen, setIsOpen] = useState(true);

  // Dynamically calculate color based on position.
  // Hue 120 is Green, Hue 60 is Yellow, Hue 0 is Red.
  const getColorForPosition = (pos) => {
    const hue = Math.max(0, 120 - (pos - 1) * 1.5);
    return `hsl(${hue}, 80%, 60%)`;
  };

  return (
    <div className="splits-container">
      <div className="splits-header">
        <div>
          <span className="runner-name">{data.name}</span>
          <span className="runner-team">Strekktider, fellesposter</span>
        </div>
        <button className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Skjul Strekktider" : "Vis Strekktider"}
        </button>
      </div>

      {isOpen && (
        <div className="splits-scroll-area">
          {data.splits.map((split) => (
            <div className="split-column" key={split.control}>
              <div className="split-control-number">{split.control}</div>

              <div className="split-data-block">
                <span className="time-label">Strekk</span>
                <div className="time-value">
                  {split.legTime}
                  <span
                    className="position"
                    style={{ color: getColorForPosition(split.legPos) }}
                  >
                    ({split.legPos})
                  </span>
                </div>
              </div>

              <div className="split-data-block">
                <span className="time-label">Etappe</span>
                <div className="time-value">
                  {split.totalTime}
                  <span
                    className="position"
                    style={{ color: getColorForPosition(split.totalPos) }}
                  >
                    ({split.totalPos})
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
